/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import Container from 'components/Container/Container';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/features-hero.s... Remove this comment to see the full error message
import BgSvg from 'components/Img/features-hero.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/manin-peace.svg... Remove this comment to see the full error message
import ManInPace from 'components/Img/manin-peace.svg';
import config from 'config';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import ClaimsForm from 'components/ClaimsForm/ClaimsForm';

import { Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    '@keyframes peaceicon': {
      '0%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
      '50%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,17)',
      },
      '100%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      fallbacks: [
        {
          backgroundImage: 'linear-gradient(-30deg, #00004d 0%, #5333ed 49%, #2cd4d9 100%)',
        },
      ],
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
    container100: {
      height: '100%',
    },
    containerFeatures: {
      paddingTop: 50,
      zIndex: 99,
      position: 'relative',
      top: -100,
      backgroundColor: '#e1eaf8',
      paddingBottom: 72,
      '&:after': {
        height: 72,
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        content: '" "',
        display: 'block',
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'><polygon fill='#fff' points='0,40 0,100 100,100 0,0' /></svg>\")",
        backgroundRepeat: 'no-repeat',
      },
    },
    paperFeatures: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(10),
    },
    typoWithIcon: {
      display: 'inline-flex',
    },
    iconsWithText: {
      fontSize: 28,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(3),
    },
    containerSecond: {
      position: 'relative',
      bottom: -120,
    },
    containerContentSecond: {},
    peaceicon: {
      '& g > g > g > g:nth-child(2)': {
        animationName: '$peaceicon',
        animationDuration: '3s',
        animationIterationCount: 'infinite',
      },
    },
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    paperNorrmal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    iconBox: {
      fontSize: 70,
      marginBottom: 40,
    },
    containerOver: {
      position: 'relative',
      top: -220,
    },
    manInPeace: {
      paddingTop: 40,
      paddingBottom: 50,
      backgroundImage: `url(${ManInPace})`,
      backgroundRepeat: 'no-repeat',
      // backgroundSize: 'contain',
      backgroundPosition: 'right top',
    },
  }),
  { name: 'BringerLithiumBatteries' }
);

const Home = memo(
  () => {
    const classes = useStyles();
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    const { t } = useTranslation();

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <div className={classes.bg}>
          <Container>
            <Grid container alignItems="center" className={classes.container100}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h2" component="h1" color="inherit" gutterBottom>
                  {t('public.claims')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={classes.containerFeatures}>
          <Container className={classes.containerOver}>
            <Grid container className={classes.containerSecond}>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="space-between">
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.1')}
                      </Typography>
                      <Typography>
                        {t('public.claims.2')}{' '}
                        <a href="mailto:claims@bringer.com">claims@bringer.com</a>.
                      </Typography>
                      <Typography>{t('public.claims.3')}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.4')}
                      </Typography>
                      <Typography>{t('public.claims.5')}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.6')}
                      </Typography>
                      <Typography>{t('public.claims.7')}</Typography>
                      <Typography>
                        <ol>
                          <li>{t('public.claims.8')}</li>
                          <li>{t('public.claims.9')}</li>
                          <li>{t('public.claims.10')}</li>
                          <li>{t('public.claims.11')}</li>
                          <li>{t('public.claims.12')}</li>
                        </ol>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.13')}
                      </Typography>
                      <Typography>{t('public.claims.14')}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.15')}
                      </Typography>
                      <Typography>{t('public.claims.16')}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.17')}
                      </Typography>
                      <Typography>
                        <p>
                          <strong>{t('public.claims.18')}</strong>
                        </p>
                        <p>{t('public.claims.19')}</p>
                        <p>
                          <strong>{t('public.claims.20')}</strong>
                        </p>
                        <p>{t('public.claims.21')}</p>
                        <p>
                          <strong>{t('public.claims.22')}</strong>
                        </p>
                        <p>{t('public.claims.23')}</p>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.24')}
                      </Typography>
                      <Typography>
                        <p>{t('public.claims.25')}</p>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.25.1')}
                      </Typography>
                      <Typography>
                        <p>{t('public.claims.25.2')}</p>
                      </Typography>
                      <Typography>
                        <ul>
                          <li>
                            {t('public.claims.25.3')}
                            <strong>{t('public.claims.25.4')}</strong> {t('public.claims.25.5')}
                          </li>
                          <li>
                            {t('public.claims.25.6')}
                            <strong>{t('public.claims.25.7')}</strong>
                            {t('public.claims.25.8')}
                          </li>
                          <li>
                            <strong>{t('public.claims.25.9')}</strong>
                            {t('public.claims.25.10')}
                          </li>
                          <li>
                            <strong>{t('public.claims.25.11')}</strong>
                          </li>
                          <li>
                            <strong>{t('public.claims.25.12')}</strong>
                          </li>
                          <li>
                            <strong>{t('public.claims.25.13')}</strong>
                            {t('public.claims.25.14')}
                          </li>
                        </ul>
                        <Typography>
                          <p>{t('public.claims.25.15')}</p>
                        </Typography>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.26.1')}
                      </Typography>
                      <Typography>
                        <p>
                          {t('public.claims.26.2')}
                          <strong>{t('public.claims.26.3')}</strong>
                          {t('public.claims.26.4')}
                        </p>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography variant="h4" gutterBottom paragraph>
                        {t('public.claims.26')}
                      </Typography>
                      <Typography>
                        <ol>
                          <li>{t('public.claims.27')}</li>
                          <li>{t('public.claims.28')}</li>
                          <li>{t('public.claims.29')}</li>
                          <li>{t('public.claims.30')}</li>
                          <li>{t('public.claims.31')}</li>
                          <li>
                            <p>{t('public.claims.32')}</p>
                            <p>{t('public.claims.33')}</p>
                          </li>
                        </ol>
                        <ClaimsForm />
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
        <br />
        <br />
      </>
    );
  },
  () => true
);

export default Home;
